import {generateSierpinski} from "./sierpinski"
import {createSvg} from "./svg"
import {initialViewBoxState, pan, ViewBoxState, viewBoxStateToAttr, zoom} from "./view-box"
import {subtractVectors, Vector} from "./vector"
import {Triangle} from "./geometry"

const bodyPaddingPixels = 10
const svgBorderPixels = 2

/*
 * The polygon elements making up the SVG are created once then never changed. Pan and zoom are accomplished
 * by modifying the SVG viewBox attribute.
 */
const triangles: Array<Triangle> = generateSierpinski(7)
const svg: SVGSVGElement = createSvg(triangles)

/*
 * Current zoom level and view position are tracked in this variable. Whenever a user action
 * requires it to change, the current value is used to compute the next value and the SVG
 * viewBox attribute is updated.
 */
let viewBoxState: ViewBoxState = initialViewBoxState

const updateViewBoxState = (update: (state: ViewBoxState) => ViewBoxState): void => {
    const newState = update(viewBoxState)
    viewBoxState = newState
    svg.setAttribute('viewBox', viewBoxStateToAttr([svg.clientWidth, svg.clientHeight], newState))
}

// Track the cursor position at the previous mouse event while dragging. Null indicates no drag in progress.
let dragPosition: Vector | null = null
svg.addEventListener('mousedown', (e) => {dragPosition = [e.screenX, e.screenY]})
svg.addEventListener('mouseup', () => {dragPosition = null})
svg.addEventListener('mouseleave', () => {dragPosition = null})

svg.addEventListener('mousemove', e => {
    if (dragPosition) {
        const newDragPosition: Vector = [e.screenX, e.screenY]
        updateViewBoxState(pan([svg.clientWidth, svg.clientHeight], subtractVectors(newDragPosition, dragPosition)))
        dragPosition = newDragPosition
    }
})

svg.addEventListener('wheel', e => {
    const svgSize: Vector = [svg.clientWidth, svg.clientHeight]

    const location: Vector = [
        e.clientX - bodyPaddingPixels - svgBorderPixels,
        e.clientY - bodyPaddingPixels - svgBorderPixels
    ]

    updateViewBoxState(zoom(svgSize, location, e.deltaY))
})

let resizeDebouncing = false

// Resize may change the viewport aspect ratio such that a new fractal level is required.
window.addEventListener('resize', () => {
    if (!resizeDebouncing) {
        resizeDebouncing = true

        setTimeout(() => {
            updateViewBoxState(state => state)
            resizeDebouncing = false
        }, 100)
    }
})

document.body.style.padding = `${bodyPaddingPixels}px`
svg.classList.add('greedy')
svg.style.cursor = 'move'
svg.style.border = `${svgBorderPixels}px solid black`

document.body.appendChild(svg)
updateViewBoxState(state => state)



// WEBPACK FOOTER //
// ./src/index.ts